module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('div', {
    staticClass: "danwei-warp"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.danwei))]), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v(_vm._s(_vm.row.saiqu.name))]), _vm._v(" "), _c('div', {
    staticClass: "duiwu"
  }, [_vm._v(_vm._s(_vm.row.mingcheng))])]), _vm._v(" "), _c('div', {
    staticClass: "step-warp"
  }, [_c('van-steps', {
    attrs: {
      "direction": "vertical",
      "active-color": "#00B388",
      "active": _vm.active
    }
  }, [_c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("填写秩序册")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("完善队伍信息")])])]), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("完善项目信息")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("选择项目以及相关运动员")]), _vm._v(" "), (_vm.row.memberstatus == 1 || _vm.row.memberstatus == 2) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormFamliyStep2',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormFamliyStep2',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-0"
  }, [_vm._v("修改信息")]) : _vm._e()])]), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确认订单并支付")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("完善发票信息，支付费用")]), _vm._v(" "), (_vm.row.isDanweiUser && _vm.row.memberstatus == 4) ? _c('div', {
    staticClass: "right tiny-btn-0"
  }, [_vm._v("确认订单")]) : _vm._e(), _vm._v(" "), (_vm.row.isDanweiUser && (_vm.row.memberstatus == 2 || _vm.row.memberstatus == 5)) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep5',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep5',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-1"
  }, [_vm._v("支付费用")]) : _vm._e()])]), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("报名成功,上传视频")]), _vm._v(" "), (_vm.row.memberstatus == 6) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyVideoList',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyVideoList',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-1"
  }, [_vm._v("上传视频")]) : _vm._e()])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-578d430a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFamliyDetail.vue
// module id = 2405
// module chunks = 0